import ScrollMagic from 'scrollmagic';

import {scrolEvents} from './default';
import {loading} from './loading';
import {index} from './index';
import {vm} from './vm';

document.addEventListener('DOMContentLoaded', function() {
	let scene = [];
	let controller;
    controller =  new ScrollMagic.Controller();
    
    // LOADING 処理
    const keyName = 'visited';
    const keyValue = true;

    if (!sessionStorage.getItem(keyName)) {
        sessionStorage.setItem(keyName, keyValue);
        loading();
    } else {
        const intro = document.getElementById('intro');
        if(intro){
            intro.remove();
        }
        index();
    }

    vm();
    scrolEvents(controller , scene);
});